export enum FormType {
  EDIT = 'edit',
  ADD = 'add',
}
